import { FC } from 'react'
import { Flex } from '@/common/layout'

export const PageFilters: FC = ({ children }) => {
  return <Flex align="center">{children}</Flex>
}
